module.exports = __webpack_public_path__ + "media/images/social-share-button/google_bookmark-524f99e4fffb564dda3795ff984477b9.svg";